import React from 'react';
import { motion } from 'framer-motion';
export function FooterCTA() {
  return <section className="py-24 md:py-32 bg-brand-black industrial-texture relative overflow-hidden" data-id="element-56">
      {/* Background industrial image */}
      <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1400&q=60&auto=format&fit=crop" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-15" data-id="element-57" />
      {/* Dark overlay to ensure text readability */}
      <div className="absolute inset-0 bg-brand-black/85 z-0" data-id="element-58" />

      <div className="max-w-[1280px] mx-auto px-6 lg:px-20 relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center" data-id="element-60">
          <h2 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-brand-white uppercase tracking-industrial mb-8 leading-tight" data-id="element-61">
            Ești pregătit să înveți o meserie cu care te descurci toată viața?
          </h2>

          <p className="font-body text-xl text-brand-muted mb-12 max-w-2xl mx-auto" data-id="element-62">
            Programează o sesiune gratuită de mentorat cu mine și hai să vedem
            împreună care este următorul pas potrivit pentru tine.
          </p>

          <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="inline-block text-center bg-brand-accent text-brand-black font-heading font-bold uppercase tracking-industrial px-10 py-6 rounded-[4px] hover:bg-white transition-all duration-300 accent-glow-hover text-lg w-full sm:w-auto" data-id="element-63">
            Programează Sesiunea Gratuită de Mentorat
          </a>
        </motion.div>
      </div>
    </section>;
}